import { HomeArtworksDisplayState } from './display.types';

export const getDefaultDisplay = (): HomeArtworksDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: HomeArtworksDisplayState = getDefaultDisplay();
